<ng-container #vc></ng-container>

<div class="row d-flex flex-row-reverse">
    <div class="col-12 col-md-6 col-lg-6 col-xl-6 pt-2" *ngIf="isReportEnabled">
        <form-due-at [formData]="formData" [inline]="true"></form-due-at>
    </div>
</div>
